import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "../../api/constant";
import type {
  department,
  departmentByIdResponse,
  departmentResponse,
} from "@/interface/department.interface";

export const DepartmentService = {
  createDepartment: async (
    payload: department,
  ): Promise<departmentResponse> => {
    const API = `${API_ENDPOINT.Department}`;
    return callApi<departmentResponse>(API, { method: "POST", data: payload });
  },

  getDepartment: async (): Promise<departmentResponse> => {
    const API = `${API_ENDPOINT?.Department}`;
    return callApi<departmentResponse>(API, { method: "GET" });
  },

  updateDepartment: async (
    payload: department,
    id: string,
  ): Promise<departmentResponse> => {
    const API = `${API_ENDPOINT?.Department}/${id}`;
    return callApi<departmentResponse>(API, { method: "PUT", data: payload });
  },

  deleteDepartment: async (id: string): Promise<departmentResponse> => {
    const API = `${API_ENDPOINT?.Department}/${id}`;
    return callApi<departmentResponse>(API, { method: "DELETE" });
  },

  getDepartmentById: async (id: string): Promise<departmentByIdResponse> => {
    const API = `${API_ENDPOINT?.Department}/${id}`;
    return callApi<departmentByIdResponse>(API, { method: "GET" });
  },
};
